import { CopilotBotComponent } from "./copilot/copilot-bot/copilot-bot.component";
import { CopilotComponent } from "./copilot/copilot.component";
import { XwaiV2StreamComponent } from "./xwai-v2/stream/xwai-v2-stream.component";
import { CostsAnalysisDashboardComponent } from "./costs/costs-analysis-dashboard/costs-analysis-dashboard.component";
import { Ec2InstancesPageComponent } from "./ec2-instances/ec2-instances-page/ec2-instances-page.component";
import { AuthGuardService } from "./shared/services/auth-guard.service";
import { XwaiV2ShellComponent } from "./xwai-v2/shell/xwai-v2-shell.component";

const privateRoutes = [
  {
    path: "xwai",
    canActivate: [AuthGuardService],
    component: CopilotComponent,
    children: [
      {
        path: "",
        redirectTo: "chat",
        pathMatch: "full",
      },
      {
        path: "chat",
        component: CopilotBotComponent,
      },
    ],
  },
  {
    path: "xwai-v2",
    canActivate: [AuthGuardService],
    component: XwaiV2ShellComponent,
  },
  {
    path: "xwai-v2-stream",
    redirectTo: "xwai-v2"
    // component: XwaiV2StreamComponent,
  },
  { path: "cost-analysis", component: CostsAnalysisDashboardComponent },
  {
    path: "ec2-instances",
    component: Ec2InstancesPageComponent,
    canActivate: [AuthGuardService],
  },
];

export default privateRoutes;
